export const ALIAS_MIN_LENGTH = 3;
export const ALIAS_MAX_LENGTH = 255;
export const CREDIT_CARD_NUMBER_LENGTH = 4;
export const CREDIT_CARD_EXPIRE_DATE = 5;
